import { Router } from '@angular/router';
import { SettingsService } from './../_services/settings.service';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit {

  feedbackreason:any[]=[]
  selectedres:any;
  answer: any;
  ReasonRequired:any
  successMessage: any;
  errorMessage: any;

  constructor(private settingsservice : SettingsService,private _localstorageservice : LocalStorageService,
    private router : Router) { }

  ngOnInit() {
    this.feedbackreason =[
      "The provided contact details were wrong",
      "I don't understand how it works",
      "I didn't get enough results",
      "Webbtree is too expensive for me",
      "I didn't receive the confirmation email",
      "The plugin popup is too intrusive",
      "Other",
    ]
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  

  selectedreason(reason){
    this.selectedres = reason
  }

  submitreason(){
    if(this.selectedres =='Other' && this.answer == undefined){
      this.ReasonRequired = "Answer is Required"
    }
    else if(this.selectedres !='Other' && this.selectedres == undefined){
      this.ReasonRequired = "Reason is Required"
    }
    else{
      this.ReasonRequired = ''
      let data ={
        userid  : this._localstorageservice.getItem('userid'),
        comment : this.selectedres =='Other' ? this.answer : this.selectedres,
        action  : "uninstall"
      }
      this.settingsservice.giveFeedback(data).subscribe((res:any)=>{
        if(res.status == 'success'){
          this.toastmessage("Feedback Given Successfully",'success')
          setTimeout(() => {
            this.router.navigateByUrl('/login')
        }, 1000);
        }else{
          this.toastmessage("Something Went Wrong",'success')
        }
      })
    }
  
  }
}
